/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */
import * as React from "react";
import "/node_modules/bootstrap/dist/css/bootstrap.min.css";
import "/node_modules/react-toastify/dist/ReactToastify.css";
import "/node_modules/swiper/swiper-bundle.css";
import "/node_modules/swiper/swiper.css";
import "@styles/assets/css/general.css";
import "@styles/assets/css/custom.css";
import "@styles/assets/css/style.css";
import "@styles/assets/css/queries.css";
import "@styles/assets/css/landing.css";
import "aos/dist/aos.css";
import "react-phone-input-2/lib/style.css";
import "animate.css";
import "react-phone-input-2/lib/style.css";
import AOS from "aos";
import PropTypes from "prop-types";
import { ToastContainer } from "react-toastify";
// import Helmet from "react-helmet";
import { Chat } from "@core/const";
import Footer from "@components/common/footer";
import SocialLinks from "@components/common/social-links";
import LandingHeader from "@components/common/landing-header";

const Layout = (props) => {
  const { children, db } = props;

  React.useEffect(() => {
    Chat();
    AOS.init();
  }, []);

  return (
    <React.Fragment>
      {/* <Helmet>
        <script>
          {`(function (l, e, a, d, i, n, f, o) {
            if (!l[i]) {
              l.GlobalLeadinfoNamespace = l.GlobalLeadinfoNamespace || [];
              l.GlobalLeadinfoNamespace.push(i);
              l[i] = function () {
                (l[i].q = l[i].q || []).push(arguments);
              };
              l[i].t = l[i].t || n;
              l[i].q = l[i].q || [];
              o = e.createElement(a);
              f = e.getElementsByTagName(a)[0];
              o.async = 1;
              o.src = d;
              f.parentNode.insertBefore(o, f);
            }
          })(
            window,
            document,
            "script",
            "https://cdn.leadinfo.net/ping.js",
            "leadinfo",
            "LI-65F026568A000"
          )`}
        </script>
      </Helmet> */}
      <LandingHeader db={db} />
      <SocialLinks />
      {children}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        limit={1}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Footer db={db} />
    </React.Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
